import React, { useEffect, useState } from "react";
import Header from "../Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Toast,
  handleGetApiGF,
  Userlogin,
  ShareurlWithImg,
  shareIphonePostMsg,
  sendMsgWhatsapp,
  formateNumberStNdRd,
  handlePostApiGF,
  GetDealerdata,
} from "../Utils/general-function";
import Loader from "../Utils/Loader";
import Info from "../Utils/Info";
import Titleinfo from "../Utils/Titleinfo";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Slider from "react-slick";

function CustomerCarDetail(props) {
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [customerCarCount, setCustomerCarCount] = useState(0); // if car is sold then show button to navigate to customer car list page with car count
  const [showBranding, setShowBranding] = useState(false);
  const navigate = useNavigate();
  const [dealerData, setDealerData] = useState({});
  let params = useParams();
  const iphone = window.navigator.userAgent.includes("Mac");
  // alert(navigator.userAgent);

  const fetchCarDet = async () => {
    if (!params?.carRand) {
      navigate("/Login");
      Toast(false, "", "Missing Parameter");
      return;
    }
    const obj = new URLSearchParams({ Randno: params?.carRand }).toString();
    const res = await handleGetApiGF({
      url: "/api/CarthiClientSellInquiry/CarthiClientSellcarbyRand?" + obj,
    });
    if (!res?.succ) {
      Toast(false, "", res?.msg || "Something went wrong!");
      return;
    }
    setDetails(res?.data?.Data || {});
    if (res?.data?.Data?.CarStatus === "Sold") {
      // if car is sold
      fechCustomerCarCount();
      return;
    }
  };

  const fechCustomerCarCount = async () => {
    //  if car is sold and then  fetch customer car count and show in button which navigate to customer car list

    const res = await handleGetApiGF({
      url: "/api/Carmaster/Dashboardcounter",
    });

    if (!res?.succ) {
      Toast(false, "", res?.msg);
      return;
    }
    setCustomerCarCount(res?.data?.Data?.TotalCustomercar || 0);
  };

  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
    }
    try {
      fetchCarDet();
      GetDealerdata().then((val) => {
        console.log("val", val);
        setDealerData(val || {});
      });
    } catch (error) {
      console.error(error?.message || "Catch Error:Something went wrong");
    }
  }, []);

  const mainSettings = {
    // asNavFor: nav2,
    // ref: (slider1) => setNav1(slider1),
    infinite: true,
    autoplaySpeed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    draggable: true,
    useTransform: true,
  };

  const onSubmitInquiry = async () => {
    // when a dealer want to see others dealer detail
    // if (!Validate()) return;
    setLoading(true);

    var param = {
      nDealerRandno: details?.clientprofilerand,
      Name: dealerData?.Firmname || localStorage.getItem("Ca1nioamed"),
      Contactno: localStorage.getItem("loginMobile") || dealerData?.Mobileno,
      Carno: details?.carnumber,
      nRemarks: "Lead from Cars from customer",
      salesexecutiveId: "0",
      LeadType: "Customerlead", // when dealer get customer contact details
      Modelid: "0", // backend will get based on car no so here pass static 0
    };
    console.log("param", param);

    try {
      let res = await handlePostApiGF({
        url: "/api/LeadQRCode/AddLeadQRCode",
        obj: param,
      });

      if (res.succ || res.msg === "Lead Already Exists") {
        setShowBranding(true);
      } else {
        Toast(res.succ, res.msg, res.msg);
      }
    } finally {
      setLoading(false);
    }
  };

  function handleload() {
    setLoading(false);
  }
  console.log("details", details);

  return (
    <div>
      {Userlogin() && <Header />}
      {loading ? <Loader /> : null}

      {details?.CarStatus === "UnSold" ? (
        <>
          {Userlogin() && (
            <div className="fixshare">
              <button
                onClick={(e) => {
                  let url = new URL(
                    `/#/customercardetail/${params?.carRand}`,
                    window.location.origin,
                  ).href;
                  ShareurlWithImg({
                    url,
                    text: `${details?.modelyear} ${details?.companyid} ${details?.carmodelid} ${details?.variantid}`,
                  });
                }}
                className="sharebtn"
              >
                Share
                <span>
                  <img src="assets/images/share.png" alt="" />
                </span>
              </button>
            </div>
          )}
          <div className="page-space mb56" style={{ marginTop: "-70px" }}>
            <div id="forshare" style={{ paddingTop: "60px" }}>
              {/* <Titleinfo
                dataFromParent={{ data: details, carno: details?.carnumber }}
              /> */}

              <div className="position-relative">
                <div className="carslider carslider npd2">
                  <Slider {...mainSettings}>
                    {/* front main photo which is not provided in seprate obj in array so statically get and show outside map loop*/}
                    <div className="car-reldiv">
                      <TransformWrapper>
                        <TransformComponent>
                          <img
                            src={details?.carphoto}
                            className="car-image"
                            alt=""
                            onLoad={handleload}
                          />
                        </TransformComponent>
                      </TransformWrapper>
                    </div>
                    {details?.catlogephotolist?.length > 0 &&
                      details?.catlogephotolist.map((list, index) => (
                        <>
                          <div className="car-reldiv" key={list.carphoto}>
                            <TransformWrapper>
                              <TransformComponent>
                                <img
                                  src={list.carphoto}
                                  className="car-image"
                                  alt=""
                                  onLoad={handleload}
                                />
                              </TransformComponent>
                            </TransformWrapper>
                          </div>
                        </>
                      ))}
                  </Slider>
                </div>
              </div>
              <div style={{ margin: "15px" }}>
                <>
                  <Titleinfo
                    dataFromParent={{
                      data: details,
                      carno: details?.carnumber,
                    }}
                  />

                  {details?.nCity && (
                    <div
                      style={{
                        display: "flex",
                        margin: "-13px 0px 19px",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span className="material-symbols-outlined  text-center text-danger bold">
                        pin_drop
                      </span>
                      <span>
                        {details?.nCity}, {details?.nState}
                      </span>
                    </div>
                  )}
                </>

                {/* old */}
                {details?.Mobileno &&
                  (iphone ? (
                    <div
                      onClick={() =>
                        shareIphonePostMsg({
                          action: "open_url_linking",
                          url: "tel:" + details?.Mobileno,
                        })
                      }
                      className="text-center mb-2"
                      style={{ marginTop: "-7px" }}
                    >
                      <Link className="ctwicon">
                        <span class="material-symbols-outlined">call</span>
                        {details?.Mobileno}
                      </Link>
                    </div>
                  ) : (
                    <div
                      className="text-center mb-2"
                      style={{ marginTop: "-7px" }}
                    >
                      <Link to={`tel:${details?.Mobileno}`} className="ctwicon">
                        <span class="material-symbols-outlined">call</span>
                        {details?.Mobileno}
                      </Link>
                    </div>
                  ))}

                {/* new one for get seller data */}
                {/* {details?.Mobileno &&
                  (showBranding ? (
                    iphone ? (
                      <div
                        onClick={() =>
                          shareIphonePostMsg({
                            action: "open_url_linking",
                            url: "tel:" + details?.Mobileno,
                          })
                        }
                        className="text-center mb-2"
                        style={{ marginTop: "-7px" }}
                      >
                        <Link className="ctwicon">
                          <span class="material-symbols-outlined">call</span>
                          {details?.Mobileno}
                        </Link>
                      </div>
                    ) : (
                      <div
                        className="text-center mb-2"
                        style={{ marginTop: "-7px" }}
                      >
                        <Link
                          to={`tel:${details?.Mobileno}`}
                          className="ctwicon"
                        >
                          <span class="material-symbols-outlined">call</span>
                          {details?.Mobileno}
                        </Link>
                      </div>
                    )
                  ) : (
                    <div className="text-center mb-3 mt-2">
                      <div className="animbtndiv">
                        <button
                          className="web-btn w-100 mt-2"
                          onClick={onSubmitInquiry}
                        >
                          Get Seller Details
                        </button>
                        <div className="circle c-1"></div>
                        <div className="circle c-2"></div>
                      </div>
                    </div>
                  ))} */}

                {/* new one for get seller data */}
              </div>
              <Info dataFromParent={details} />
              <div
                class="pt-4 text-center"
                onClick={() => {
                  let text = `The customer's car has been sold, \nCar Number : ${details?.carnumber}, \nMobile Number : ${details?.Mobileno}`;
                  sendMsgWhatsapp({ text });
                }}
              >
                {Userlogin() && (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <button
                      style={{
                        backgroundColor: "#f8e6e6ff",
                        color: "#bd1717ff",
                        border: ".5px solid #bd1717ff",
                        borderRadius: "6px",
                        padding: "3px",
                      }}
                    >
                      Is this car sold ?, Please update the status{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        style={{ fill: "rgba(180, 23, 23, 1)" }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263"
                        ></path>
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="soldout-div">
          <img
            src="assets/images/sorry-soldout.png"
            alt=""
            className="soldimg"
            onLoad={handleload}
          />
          <p className="soldmsg">
            Thanks for your interest! The car you’re looking for has already
            been sold. But don’t worry — we have many other great options
            waiting for you. Check them out!
          </p>
          <div class="pt-4 text-center">
            <div style={{ position: "relative", display: "inline-block" }}>
              <Link
                to="/customercarlist"
                state={{ carcount: customerCarCount || 0 }}
                class="super-button"
              >
                <span>{customerCarCount}</span>Cars From Customers
                <svg fill="none" viewBox="0 0 24 24" class="arrow">
                  <path
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke-width="2"
                    stroke="currentColor"
                    d="M5 12h14M13 6l6 6-6 6"
                  ></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomerCarDetail;
